import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router';

import { AppLayout } from '@/components/layout/AppLayout';

export const Route = createFileRoute('/missions')({
	component: MissionsLayout,
});

function MissionsLayout() {
	const leafMatch = useMatches({
		select: (matches: Array<{ staticData?: { restrictScroll?: boolean } }>) =>
			matches.at(-1),
	});
	const restrictScroll = leafMatch?.staticData?.restrictScroll ?? false;

	return (
		<AppLayout restrictScroll={restrictScroll}>
			<Outlet />
		</AppLayout>
	);
}
